import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "container mx-auto text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "inline-block pb-2 text-gold text-3xl font-audiowide mb-2" }, " NFT Bridge ", -1)
const _hoisted_3 = { class: "relative z-10 flex items-end font-audiowide" }
const _hoisted_4 = { class: "border border-white border-opacity-25 overflow-x-auto" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "h-8"
}
const _hoisted_7 = { class: "divide-y" }
const _hoisted_8 = { class: "flex justify-end p-3" }
const _hoisted_9 = {
  key: 1,
  class: "mx-6 flex py-6"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-8 w-8 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "ml-2 mt-1" }, "Loading your NFTs", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "mx-6 py-6"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("You have no ships yet. Go get some on ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "//cometh.io",
  target: "_blank",
  class: "underline hover:text-gold"
}, "cometh.io", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "divide-y" }
const _hoisted_18 = {
  key: 0,
  class: "h-8"
}
const _hoisted_19 = {
  key: 0,
  class: "transition absolute flex inset-0 bg-black bg-opacity-90 items-center justify-center text-red-500 font-audiowide"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 -ml-1 mr-2 inline",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_NftItem = _resolveComponent("NftItem")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'ENTER')),
          class: _normalizeClass(["flex rounded-t px-4 items-center cursor-pointer", [
                        _ctx.activeTab === 'ENTER'
                            ? 'border border-white border-opacity-25 border-b-0 border-b-black -mb-px py-2 bg-black'
                            : 'text-gray-600 bg-gray-800 py-1'
                    ]])
        }, " ENTER ", 2),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'EXIT')),
          class: _normalizeClass(["flex rounded-t px-4 items-center cursor-pointer", [
                        _ctx.activeTab === 'EXIT'
                            ? 'border border-white border-opacity-25 border-b-0 border-b-black -mb-px py-2 bg-black'
                            : 'text-gray-600 bg-gray-800 py-1'
                    ]])
        }, " EXIT ", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.isOnCorrectNetwork)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            (_ctx.shipsEnter.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Button, {
                      enabled: !_ctx.isApprovedForAll,
                      onClick: _ctx.approveForAll,
                      loading: _ctx.loadingApproveForAll,
                      class: "bg-yellow-600 border-yellow-700 hover:bg-yellow-500 hover:border-yellow-600"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isApprovedForAll ? 'Approve All Enabled' : 'Approve All'), 1)
                      ]),
                      _: 1
                    }, 8, ["enabled", "onClick", "loading"])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipsEnter, (nft) => {
                    return (_openBlock(), _createBlock(_component_NftItem, {
                      nft: nft,
                      networkId: _ctx.networkId,
                      key: nft.id,
                      isApprovedForAll: _ctx.isApprovedForAll
                    }, null, 8, ["nft", "networkId", "isApprovedForAll"]))
                  }), 128))
                ], 64))
              : (_ctx.loadingNFTs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                : (_ctx.isOnCorrectNetwork)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                  : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.activeTab === 'ENTER']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_17, [
            (!_ctx.shipsExit.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipsExit, (nft) => {
              return (_openBlock(), _createBlock(_component_NftItem, {
                nft: nft,
                networkId: _ctx.networkId,
                key: nft.id
              }, null, 8, ["nft", "networkId"]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.activeTab === 'EXIT']
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (
                                (_ctx.activeTab === 'ENTER' && _ctx.networkId !== _ctx.config.l1NetworkId) ||
                                    (_ctx.activeTab === 'EXIT' && _ctx.networkId !== _ctx.config.l2NetworkId)
                            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      _createTextVNode(" Please connect to " + _toDisplayString(_ctx.activeTab === 'ENTER' ? _ctx.config.l1NetworkLabel : _ctx.config.l2NetworkLabel), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}